<template>
  <div class="settles">
    <div class="head-box">
      <h4>结算单列表</h4>
      <div class="c-flex">
        <el-input
          placeholder="请输入结算单标题/结算单据号"
          v-model="searchValue"
          class="c-search"
          clearable
          @clear="
            fpi.page = 1;
            getData();
          "
          @keyup.enter.native="
            fpi.page = 1;
            getData();
          "
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="
              fpi.page = 1;
              getData();
            "
          ></el-button>
        </el-input>
        <el-button type="primary" @click="doNew(1)" class="c-m-l-10"
          >新增结算单</el-button
        >
        <!-- <el-button type="primary" @click="doNew(0)" class="c-m-l-10" v-has="'Settles,unlockPay'">
          新增未解付结算单
        </el-button> -->
        <el-dropdown class="c-m-l-10" @command="audit" v-has="'Settles,audit'">
          <el-button type="primary">
            审核
            <i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="1">提交审核</el-dropdown-item>
            <el-dropdown-item command="2">撤回修改</el-dropdown-item>
            <el-dropdown-item command="3">审核通过</el-dropdown-item>
            <el-dropdown-item command="4">审核不通过</el-dropdown-item>
            <el-dropdown-item command="5">反审</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-dropdown
          class="c-m-l-10"
          @command="audit"
          v-has="'Settles,submitAudit'"
        >
          <el-button type="primary">
            提交审核
            <i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="1">提交审核</el-dropdown-item>
            <el-dropdown-item command="2">撤回修改</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <div class="content-box">
      <div class="content-filter">
        <c-filter></c-filter>
      </div>
      <div class="content-table">
        <el-table
          ref="table"
          height="calc(100% - 50px)"
          :data="fpi.data"
          @selection-change="selectSettles"
          highlight-current-row
        >
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column
            label="结算单标题"
            fixed
            width="200px"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <el-button
                @click.native.prevent="
                  $router.push({ path: `/Settle/${scope.row._id}` })
                "
                type="text"
              >
                {{ scope.row.title }}
              </el-button>
            </template>
          </el-table-column>
          <el-table-column
            prop="num"
            label="结算单据号"
            width="150px"
            show-overflow-tooltip
          ></el-table-column>
          <!-- <el-table-column
            prop="type"
            label="结算对象"
            width="120px"
            show-overflow-tooltip
            :formatter="formatType"
          ></el-table-column> -->
          <el-table-column
            prop="sourceType"
            label="结算来源类型"
            width="120px"
            show-overflow-tooltip
            :formatter="formatSourceType"
          ></el-table-column>
          <!-- <el-table-column
            prop="exts.contractSubject"
            label="公司主体"
            width="120px"
            show-overflow-tooltip
            :formatter="formatContractSubject"
          ></el-table-column> -->
          <el-table-column
            prop="sourceTypeType"
            label="类型"
            width="120px"
            show-overflow-tooltip
            :formatter="formatSourceTypeType"
          ></el-table-column>
          <el-table-column
            prop="toId"
            :label="
              tenantId == '5103793983082511283' ? '服务商/工队' : '服务商'
            "
            width="180px"
            show-overflow-tooltip
            :formatter="formatToId"
          ></el-table-column>
          <!-- <el-table-column label="结算开始时间" width="140" show-overflow-tooltip>
            <template slot-scope="scope">
              {{ scope.row.startTime || '不限制' }}
            </template>
          </el-table-column>
          <el-table-column label="结算结束时间" width="140" show-overflow-tooltip>
            <template slot-scope="scope">
              {{ scope.row.endTime || '不限制' }}
            </template>
          </el-table-column> -->
          <el-table-column
            label="创建日期查询条件"
            width="200"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <!-- {{
                !scope.row.startTime && !scope.row.endTime
                  ? '不限制'
                  : (scope.row.startTime || '不限制') + ' 至 ' + (scope.row.endTime || '不限制')
              }} -->
              <template v-if="scope.row.startTime && scope.row.endTime">
                {{ scope.row.startTime.split(" ")[0] }} 至
                {{ scope.row.endTime.split(" ")[0] }}
              </template>
              <template v-else-if="scope.row.startTime">
                从 {{ scope.row.startTime.split(" ")[0] }} 开始
              </template>
              <template v-else-if="scope.row.endTime">
                截止到 {{ scope.row.endTime.split(" ")[0] }}
              </template>
              <template v-else> 不限制 </template>
            </template>
          </el-table-column>
          <el-table-column
            label="实际完工日期查询条件"
            width="200"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <template
                v-if="
                  scope.row.exts.contractCompleteStartTime &&
                  scope.row.exts.contractCompleteEndTime
                "
              >
                {{ scope.row.exts.contractCompleteStartTime }} 至
                {{ scope.row.exts.contractCompleteEndTime }}
              </template>
            </template>
          </el-table-column>
          <el-table-column label="结算单状态" width="150px">
            <template slot-scope="scope">
              <el-tag effect="plain" v-if="scope.row.settleState == 0">
                {{ formatSettleState(scope.row.settleState) }}
              </el-tag>
              <el-tag effect="dark" v-else-if="scope.row.settleState == 1">
                {{ formatSettleState(scope.row.settleState) }}
              </el-tag>
              <el-tag
                effect="dark"
                v-else-if="scope.row.settleState == 2"
                type="success"
              >
                {{ formatSettleState(scope.row.settleState) }}
              </el-tag>
              <el-tag
                effect="dark"
                v-else-if="scope.row.settleState == 3"
                type="warning"
              >
                {{ formatSettleState(scope.row.settleState) }}
              </el-tag>
              <el-tag
                effect="dark"
                v-else-if="scope.row.settleState == 4"
                type="danger"
              >
                {{ formatSettleState(scope.row.settleState) }}
              </el-tag>
              <el-tag
                effect="dark"
                v-else-if="scope.row.settleState"
                type="info"
              >
                {{ formatSettleState(scope.row.settleState) }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column
            prop="createTime"
            label="创建时间"
            sortable
            width="150px"
          ></el-table-column>

          <el-table-column fixed="right" width="100px">
            <template slot-scope="scope">
              <el-dropdown>
                <el-button>
                  操作
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="doEdit(scope.row)">
                    编辑
                  </el-dropdown-item>
                  <el-dropdown-item @click.native="doRemove(scope.row._id)">
                    删除
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>

          <template v-for="(item, i) in extFields">
            <template v-if="item.showList && item.showList.indexOf('1') != -1">
              <!-- 判断是否在列表展示 -->
              <template v-if="!item.frontEndConfig.listHide">
                <!-- 关联字典表 -->
                <template v-if="item.valueOption">
                  <!-- 级联 -->
                  <el-table-column
                    v-if="item.type == 'cascade'"
                    :label="item.nameDisp"
                    :key="i"
                    width="150px"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      {{
                        formatCascade(
                          item.valueOption,
                          scope.row.exts[item.name]
                        )
                      }}
                    </template>
                  </el-table-column>
                  <!-- 多选 -->
                  <el-table-column
                    v-else-if="item.type == 'checkbox'"
                    :label="item.nameDisp"
                    :key="i"
                    width="150px"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      {{
                        formatArray(item.valueOption, scope.row.exts[item.name])
                      }}
                    </template>
                  </el-table-column>
                  <!-- 下拉/单选 -->
                  <el-table-column
                    v-else
                    :label="item.nameDisp"
                    :key="i"
                    width="120px"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      {{ format(item.valueOption, scope.row.exts[item.name]) }}
                    </template>
                  </el-table-column>
                </template>
                <!-- 非关联字典表 -->
                <template v-else>
                  <el-table-column
                    :prop="'exts.' + item.name"
                    :label="item.nameDisp"
                    :key="i"
                    width="120px"
                    show-overflow-tooltip
                  ></el-table-column>
                </template>
              </template>
            </template>
          </template>
        </el-table>
        <el-pagination
          class="pagination"
          @size-change="pageSizeChange"
          @current-change="pageChange"
          :current-page="fpi.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="fpi.rows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="fpi.total"
        ></el-pagination>
      </div>
    </div>
    <el-dialog
      :title="contracts.unlockPayState ? '结算单' : '未解付结算单'"
      :visible.sync="openDetail"
      custom-class="c-dialog"
    >
      <el-form
        style="display: flex; flex-wrap: wrap"
        :model="formData"
        :rules="rules"
        ref="formData"
        label-width="150px"
        label-position="left"
        class="c-form-item"
      >
        <el-form-item label="结算单标题" prop="title">
          <el-input
            v-model="formData.title"
            :disabled="
              formData.settleState != 0 && formData.settleState != undefined
            "
          ></el-input>
        </el-form-item>
        <el-form-item
          label="结算对象"
          prop="type"
          :rules="{
            required: true,
            trigger: 'change',
            message: '请选择',
          }"
        >
          <el-select
            v-model="formData.type"
            clearable
            @change="getContracts()"
            :disabled="
              formData.settleState != 0 && formData.settleState != undefined
            "
          >
            <el-option
              v-for="item in options.type"
              :key="item.value"
              :label="item.label"
              :value="Number(item.value)"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="结算来源类型"
          prop="sourceType"
          :rules="{
            required: true,
            trigger: 'change',
            message: '请选择',
          }"
        >
          <el-select
            v-model="formData.sourceType"
            clearable
            @change="
              formData.toId = '';
              formData.sourceTypeType = [];
              getContracts();
            "
            :disabled="
              formData.settleState != 0 && formData.settleState != undefined
            "
          >
            <template v-for="item in options.sourceType">
              <!-- 结算对象为对工人结算时，结算来源才展示考勤 -->
              <el-option
                :key="item.value"
                :label="item.label"
                :value="Number(item.value)"
                v-if="
                  item.value == 3 ? (formData.type == 1 ? true : false) : true
                "
              ></el-option>
            </template>
          </el-select>
        </el-form-item>
        <el-form-item class="c-date-picker">
          <template slot="label">
            {{ formatSourceType(null, null, formData.sourceType) || ""
            }}{{ formData.sourceType == 2 ? "签订" : "创建" }}日期
          </template>
          <el-date-picker
            v-model="formData.datetimerange"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            clearable
            @change="getContracts()"
            :disabled="
              formData.settleState != 0 && formData.settleState != undefined
            "
          ></el-date-picker>
        </el-form-item>
        <!-- <el-form-item label="结算开始时间">
          <el-date-picker
            v-model="formData.startTime"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="不选择时间则不限制"
            clearable
            @change="getContracts()"
            :disabled="formData.settleState != 0 && formData.settleState != undefined"
          ></el-date-picker>
        </el-form-item> -->
        <!-- <el-form-item label="结算结束时间">
          <el-date-picker
            v-model="formData.endTime"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="不选择时间则不限制"
            default-time="23:59:59"
            clearable
            @change="getContracts()"
            :disabled="formData.settleState != 0 && formData.settleState != undefined"
          ></el-date-picker>
        </el-form-item> -->
        <!-- <el-form-item
          label="公司主体"
          prop="exts.contractSubject"
          :rules="{
            required: true,
            trigger: 'change',
            message: '请选择'
          }"
        >
          <el-select
            v-model="formData.exts.contractSubject"
            clearable
            @change="getContracts()"
            :disabled="formData.settleState != 0 && formData.settleState != undefined"
          >
            <el-option
              v-for="item in options.contractSubject"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item> -->
        <!-- 结算来源类型为2合同时 -->
        <el-form-item
          v-if="formData.sourceType == 2"
          label="合同类型"
          prop="sourceTypeType"
          :rules="{
            required: true,
            trigger: ['blur', 'change'],
            message: '请选择',
          }"
        >
          <el-select
            v-model="formData.sourceTypeType"
            clearable
            multiple
            @change="
              $forceUpdate();
              getContracts();
            "
            :disabled="
              formData.settleState != 0 && formData.settleState != undefined
            "
          >
            <el-option
              v-for="item in options.contractType"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="formData.sourceType == 2" class="c-date-picker">
          <template slot="label"> 合同实际完工日期 </template>
          <el-date-picker
            v-model="formData.contractCompleteTime"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="合同实际完工日期"
            end-placeholder="合同实际完工日期"
            clearable
            @change="getContracts()"
            :disabled="
              formData.settleState != 0 && formData.settleState != undefined
            "
          ></el-date-picker>
        </el-form-item>
        <el-form-item
          v-if="formData.sourceType == 2 && tenantId == '1340835581184723420'"
          label="是否京东分账"
          prop="exts.ledgerJD_is"
          :rules="{
            required: true,
            trigger: 'change',
            message: '请选择',
          }"
        >
          <el-select
            v-model="formData.exts.ledgerJD_is"
            clearable
            @change="
              $forceUpdate();
              getContracts();
            "
            :disabled="
              formData.settleState != 0 && formData.settleState != undefined
            "
          >
            <el-option
              v-for="item in options.ledgerJD_is"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          v-if="formData.sourceType == 2 && tenantId == '1340835581184723420'"
          label="信息来源"
          prop="exts.contractSourceType"
        >
          <el-select
            v-model="formData.exts.contractSourceType"
            clearable
            @change="
              $forceUpdate();
              getContracts();
            "
            :disabled="
              formData.settleState != 0 && formData.settleState != undefined
            "
          >
            <el-option
              v-for="item in options.contractSourceType"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          v-if="formData.sourceType == 2 && tenantId == '1340835581184723420'"
          label="是否工程类项目"
          prop="exts.project_is"
        >
          <el-select
            v-model="formData.exts.project_is"
            clearable
            @change="
              $forceUpdate();
              getContracts();
            "
            :disabled="
              formData.settleState != 0 && formData.settleState != undefined
            "
          >
            <el-option
              v-for="item in options.project_is"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- 0 平台->服务商 -->
        <!-- 选择组织 -->
        <el-form-item
          label="选择服务商"
          prop="toId"
          :rules="{
            required: formData.sourceType == 2 ? true : false,
            trigger: 'change',
            message: '请选择',
          }"
          v-if="
            tenantId == '5103793983082511283' &&
            formData.type != 1 &&
            (formData.sourceType || formData.sourceType == 0)
          "
        >
          <el-select
            v-model="formData.toId"
            clearable
            filterable
            @change="getContracts(false, 'toId')"
            :disabled="
              formData.settleState != 0 && formData.settleState != undefined
            "
          >
            <el-option
              v-for="item in options.orgs"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="选择服务商"
          prop="toId"
          :rules="{
            required: formData.sourceType == 2 ? true : false,
            trigger: 'change',
            message: '请选择',
          }"
          v-if="
            tenantId != '5103793983082511283' &&
            (formData.sourceType || formData.sourceType == 0)
          "
        >
          <el-select
            v-model="formData.toId"
            clearable
            filterable
            @change="getContracts(false, 'toId')"
            :disabled="
              formData.settleState != 0 && formData.settleState != undefined
            "
          >
            <el-option
              v-for="item in options.partners"
              :key="item.value"
              :label="item.label"
              :value="formData.sourceType == 2 ? item.value : item.orgId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          v-if="
            tenantId == '5103793983082511283' &&
            formData.type == 1 &&
            (formData.sourceType || formData.sourceType == 0)
          "
          label="选择工队/工人"
          prop="toId"
          :rules="{
            required: formData.sourceType == 3 ? true : false,
            trigger: 'change',
            message: '请选择',
          }"
        >
          <el-select
            v-model="formData.toId"
            clearable
            @change="getContracts()"
            :disabled="
              formData.settleState != 0 && formData.settleState != undefined
            "
          >
            <template v-for="item in options.serviceResources">
              <!-- 按考勤结算时 只展示支持按天结算的工人 -->
              <el-option
                :key="item.value"
                :label="item.label"
                :value="item.value"
                v-if="
                  formData.sourceType == 3
                    ? item.resourceRoles &&
                      item.resourceRoles.indexOf('4') != -1
                      ? true
                      : false
                    : true
                "
              >
                <span>{{ item.label }}</span>
                <!-- 按考勤结算时展示日薪 -->
                <span
                  v-if="
                    formData.sourceType == 3 &&
                    item.exts &&
                    (item.exts.dailyWage || item.exts.dailyWage == 0)
                  "
                  style="float: right; color: #c3c6cd; font-size: 13px"
                >
                  日薪：{{ item.exts.dailyWage }}元
                </span>
              </el-option>
            </template>
          </el-select>
        </el-form-item>
        <!--  -->
         <el-form-item
          v-if="formData.sourceType == 2 && tenantId == '1340835581184723420'"
          label="是否已结清"
          prop="payState"
          :rules="{
            required: false,
            trigger: 'change',
            message: '请选择',
          }"
        >
          <el-select
            v-model="formData.payState"
            clearable
            @change="
              $forceUpdate();
              getContracts();
            "
            :disabled="
              formData.settleState != 0 && formData.settleState != undefined
            "
          >
            <el-option
              v-for="item in options.payState"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="备注"
          prop="remark"
          :rules="{
            required: contracts.unlockPayState ? false : true,
            trigger: ['blur', 'change'],
            message: '备注不能为空',
          }"
        >
          <el-input
            :rows="1"
            v-model="formData.remark"
            :disabled="
              formData.settleState != 0 && formData.settleState != undefined
            "
          ></el-input>
        </el-form-item>
        <!-- 1 平台->工队 -->
        <!-- 2 服务商->工队 -->
        <!-- 3 服务商->管家 -->
        <!-- 4 工队->工人 -->
        <!-- <template v-for="(extField, idx) in extFields">
          <el-form-item
            :key="idx"
            v-if="extField.showList && extField.showList.indexOf('2') != -1"
            :label="extField.nameDisp"
          >
            <template
              v-if="
                extField.type == 'text' || extField.type == 'textarea' || extField.type == 'number'
              "
            >
              <el-input v-model="formData.exts[extField.name]" :type="extField.type"></el-input>
            </template>
            <template v-if="extField.type == 'radio'">
              <el-radio-group v-model="formData.exts[extField.name]">
                <el-radio
                  v-for="item in options[extField.valueOption]"
                  :key="item.value"
                  :label="item.value"
                >
                  {{ item.label }}
                </el-radio>
              </el-radio-group>
            </template>
            <template v-if="extField.type == 'checkbox'" @change="$forceUpdate()">
              <el-checkbox-group v-model="formData.exts[extField.name]" @change="$forceUpdate()">
                <el-checkbox
                  v-for="item in options[extField.valueOption]"
                  :label="item.value"
                  :key="item.value"
                >
                  {{ item.label }}
                </el-checkbox>
              </el-checkbox-group>
            </template>
            <template v-if="extField.type == 'select'">
              <el-select v-model="formData.exts[extField.name]" placeholder="请选择" clearable>
                <el-option
                  v-for="item in options[extField.valueOption]"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </template>
            <template v-if="extField.type == 'cascade'">
              <el-cascader
                clearable
                v-model="formData.exts[extField.name]"
                :options="options[extField.valueOption]"
                :props="{ checkStrictly: true, label: 'name' }"
              ></el-cascader>
            </template>
            <template v-if="extField.type == 'time'">
              <el-time-select
                v-model="formData.exts[extField.name]"
                placeholder="选择时间"
              ></el-time-select>
            </template>
            <template v-if="extField.type == 'date' || extField.type == 'datetime'">
              <el-date-picker
                v-model="formData.exts[extField.name]"
                :type="extField.type"
                placeholder="选择日期"
              ></el-date-picker>
            </template>
            <template v-if="extField.type == 'switch'">
              <el-switch
                v-model="formData.exts[extField.name]"
                active-color="#13ce66"
                inactive-color="#ff4949"
                active-value="1"
                inactive-value="0"
              ></el-switch>
            </template>
            <template v-if="extField.type == 'rate'">
              <el-rate v-model="formData.exts[extField.name]" @change="$forceUpdate()"></el-rate>
            </template>
          </el-form-item>
        </template> -->
        <c-form
          label-width="150px"
          :formData="formData"
          :fields="extFields"
          :options="options"
          ref="form"
        ></c-form>

        <!-- <el-form-item>
          <el-button type="primary" @click="getContracts()">
            <span>查询</span>
            <span v-if="formData.sourceType">
              符合条件的{{ formatSourceType(null, null, formData.sourceType) }}
            </span>
          </el-button>
        </el-form-item> -->
      </el-form>
      <!-- 工单列表 -->
      <el-table
        v-if="formData.sourceType == 0"
        ref="table2"
        height="100%"
        :data="contracts.fpi.data"
        v-loading="contracts.loading"
        border
        stripe
        @selection-change="selectChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column
          prop="title"
          label="标题"
          width="145px"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="orderNum"
          label="工单编号"
          width="120px"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="name"
          label="客户名称"
          width="100px"
        ></el-table-column>
        <el-table-column
          prop="phone"
          label="客户电话"
          width="120px"
        ></el-table-column>
        <el-table-column
          prop="province"
          label="省"
          :formatter="osg.formatProvince"
          width="100px"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="city"
          label="市"
          :formatter="osg.formatCity"
          width="100px"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="district"
          label="区"
          :formatter="osg.formatDistrict"
          width="100px"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="address"
          label="详细地址"
          width="180px"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="orgName"
          label="服务商"
          width="150px"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="createTime"
          label="创建时间"
          min-width="140px"
          sortable
        ></el-table-column>
        <el-table-column
          prop="paystate"
          label="支付状态"
          min-width="100px"
          :formatter="formatPayState"
        ></el-table-column>
        <el-table-column
          prop="unlockPayState"
          label="解付状态"
          min-width="100px"
          :formatter="formatUnlockPay"
        ></el-table-column>
        <el-table-column label="产品明细" width="500px">
          <template
            slot-scope="scope"
            v-if="
              scope.row.exts.productsSnap &&
              scope.row.exts.productsSnap.length > 0
            "
          >
            <el-table :data="scope.row.exts.productsSnap">
              <el-table-column
                prop="name"
                label="规格"
                width="150px"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column prop="price" label="单价"></el-table-column>
              <el-table-column prop="costNum" label="数量"></el-table-column>
            </el-table>
          </template>
        </el-table-column>
      </el-table>
      <!-- 考勤表 -->
      <el-table
        v-else-if="formData.sourceType == 3"
        ref="table2"
        height="100%"
        :data="contracts.fpi.data"
        v-loading="contracts.loading"
        border
        stripe
        @selection-change="selectChange"
      >
        <el-table-column type="selection" width="55" fixed></el-table-column>
        <el-table-column
          prop="userId"
          label="工人姓名"
          min-width="100px"
          :formatter="formatUserId"
        ></el-table-column>
        <el-table-column
          prop="workTimeTotal"
          label="总工时(小时)"
          min-width="100px"
        ></el-table-column>
        <el-table-column
          prop="targetType"
          label="打卡对象"
          min-width="100px"
          :formatter="formatTargetType"
        ></el-table-column>
        <el-table-column
          prop="address"
          label="打卡地址"
          width="200px"
        ></el-table-column>
        <el-table-column
          prop="createTime"
          label="打卡日期"
          min-width="100px"
          :formatter="formatSignDate"
        ></el-table-column>
        <el-table-column
          prop="endTime"
          label="收工时间"
          min-width="140px"
          :formatter="formatEndDate"
        ></el-table-column>
        <el-table-column
          prop="leaderId"
          label="工长姓名"
          min-width="100px"
          :formatter="formatUserId"
        ></el-table-column>
        <el-table-column
          prop="unlockPayState"
          label="解付状态"
          min-width="100px"
          :formatter="formatUnlockPay"
        ></el-table-column>
      </el-table>
      <!-- 合同列表 -->
      <el-table
        v-else
        ref="table2"
        height="100%"
        :data="contracts.fpi.data"
        v-loading="contracts.loading"
        border
        stripe
        @selection-change="selectChange"
      >
        <el-table-column type="selection" width="55" fixed></el-table-column>
        <el-table-column
          prop="contactsName"
          label="委托方"
          min-width="150px"
          fixed
        ></el-table-column>
        <el-table-column
          prop="partyB"
          label="服务商"
          min-width="150px"
        ></el-table-column>
        <el-table-column
          prop="signedDate"
          label="签订日期"
          width="100"
        ></el-table-column>
        <el-table-column
          prop="contractdocNum"
          label="合同编号"
          min-width="170px"
          fixed
        ></el-table-column>
        <el-table-column
          prop="contactsPhone"
          label="联系电话"
          min-width="100px"
        ></el-table-column>
        <el-table-column
          prop="afterRefundMoney"
          label="合同金额"
          min-width="100px"
        ></el-table-column>
        <el-table-column
          prop="paidAmount"
          label="已支付金额"
          min-width="100px"
        ></el-table-column>
        <!-- <el-table-column
            prop="settledCardinal"
            label="已结基数金额"
            min-width="100px"
          ></el-table-column> -->
        <!-- <el-table-column
            prop="settledAmount"
            label="已结算金额"
            min-width="100px"
          ></el-table-column> -->
        <el-table-column
          prop="teamLeader"
          label="工队长"
          min-width="100px"
        ></el-table-column>
        <el-table-column
          prop="serviceHousekeeper"
          label="管家"
          min-width="100px"
        ></el-table-column>
        <el-table-column
          prop="exts.repairParts"
          label="维修部位"
          min-width="150px"
          :formatter="formatRepairParts"
        ></el-table-column>
        <!-- <el-table-column
            prop="maintainAreaNum"
            label="维修面积"
            min-width="80px"
          ></el-table-column> -->
        <!-- <el-table-column label="质保年限" min-width="80px">
            <template slot-scope="scope" v-if="scope.row.warrantyPeriod">
              {{ scope.row.warrantyPeriod }}年
            </template>
          </el-table-column> -->
        <el-table-column label="开工日期" min-width="90px">
          <template slot-scope="scope">
            <span v-if="scope.row.startDate">
              {{ scope.row.startDate.split(" ")[0] }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="完工日期" min-width="90px">
          <template slot-scope="scope">
            <span v-if="scope.row.endDate">
              {{ scope.row.endDate.split(" ")[0] }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="实际完工日期" min-width="100px">
          <template slot-scope="scope">
            <span v-if="scope.row.exts.realCompleteDate">
              {{ scope.row.exts.realCompleteDate.split(" ")[0] }}
            </span>
          </template>
        </el-table-column>
        <!-- <el-table-column
            prop="insurancedocNum"
            label="保单号"
            min-width="200px"
          ></el-table-column> -->
        <el-table-column
          prop="exts.contractStatus"
          label="签约状态"
          min-width="100px"
          :formatter="formatContractStatus"
        ></el-table-column>
        <el-table-column
          prop="payState"
          label="支付状态"
          min-width="100px"
          :formatter="formatPayState"
        ></el-table-column>
        <el-table-column
          prop="unlockPayState"
          label="解付状态"
          min-width="100px"
          :formatter="formatUnlockPay"
        ></el-table-column>
      </el-table>
      <div slot="footer">
        <div>
          共查询到
          <span class="c_blue">{{ contracts.fpi.data.length }}</span>
          条符合条件的数据，已选择
          <span class="c_blue">{{ contracts.selectedRows.length }}</span>
          条。
        </div>
        <div>
          <el-button type="primary" @click="doSave">提 交</el-button>
          <el-button @click="doInit">取 消</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog title="审核不通过" :visible.sync="auditObj.show">
      <el-form
        ref="audit"
        :model="auditObj"
        label-width="100px"
        label-position="left"
      >
        <el-form-item
          label="备注"
          prop="remark"
          placeholder="请输入备注内容"
          :rules="{
            required: true,
            trigger: ['change', 'blur'],
            message: '请输入备注内容',
          }"
        >
          <el-input v-model="auditObj.remark" type="textarea"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button
          type="primary"
          @click="auditConfirm('4', '审核不通过，处理完成。')"
        >
          确 定
        </el-button>
        <el-button
          @click="
            auditObj.show = false;
            auditObj.remark = '';
          "
        >
          取 消
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: "Settles",
  data() {
    window.$this = this;
    return {
      name: "settle",
      tenantId: null,
      fpi: {},
      contracts: {
        fpi: {
          data: [],
        },
        selectedRows: [],
        loading: false,
      },
      searchValue: "",
      openDetail: false,
      formData: {
        toId: "",
        sourceTypeType: [],
        datetimerange: [],
        contractCompleteTime: [],
        exts: {
          ledgerJD_is: "",
          project_is: "",
        },
      },
      extFields: [],
      extField: {}, //特殊字段类型 如rate值为number类型,checkbox值为数组不能为空
      rules: this.$util.rules,
      options: {
        codecfg_type: { codeId: "settleType" },
        codecfg_sourceType: { codeId: "settleSourceType" },
        codecfg_contractSourceType: { codeId: "sourceType" }, //信息来源
        codecfg_contractType: { codeId: "contractType" },
        codecfg_settleState: { codeId: "settleState" },
        cascadeCode_repairParts: { codeId: "repairParts" },
        codecfg_contractStatus: { codeId: "contractStatus" },
        codecfg_payState: { codeId: "payState1" },
        codecfg_unlockPay: { codeId: "unlockPayState" },
        codecfg_contractSubject: { codeId: "contractSubject" },
        codecfg_ledgerJD_is: { codeId: "ledgerJD_is" },
        codecfg_project_is: { codeId: "project_is" },
      },
      selectedRows: [], //勾选的结算单
      auditObj: {
        show: false,
        remark: "",
      },
    };
  },
  mounted() {
    this.tenantId = JSON.parse(sessionStorage["entity"]).tenantId;
    this.doInit();
    this.osg.ajax(
      "biz/extField/query.do",
      {
        colName: "settle",
        _all: "1",
        "is:state|integer#and": 1,
        "nin:preset|array-integer#and": 1,
        sortField: "order",
        sortOrder: "asc",
      },
      (res) => {
        this.extFields = res.data;
        this.options = this.options || {};
        for (var item of res.data) {
          //解析字段配置
          if (this.$util.isJson(item.frontEndConfig)) {
            item.frontEndConfig = JSON.parse(item.frontEndConfig);
          } else {
            item.frontEndConfig = {};
          }

          if (item.valueOption) {
            this.options["codecfg_" + item.valueOption] = {
              codeId: item.valueOption,
            };
          }
          //级联
          if (item.type == "cascade")
            this.options["cascadeCode_" + item.valueOption] = {
              codeId: item.valueOption,
            };
        }
        this.$util.renderExtField(this.extFields, this.formData);
        this.getPartners();
        this.getOrgs();
        this.getServiceResources();
        this.osg.codeoption(() => {
          this.osg.getFpi();
          this.getData();
        });
      },
      { noload: true }
    );
  },
  methods: {
    formatToId(row, column, cellValue) {
      if (row.type == 0) {
        // 平台对门店结算
        if (this.tenantId == "5103793983082511283") {
          return this.osg.codelabel("orgs", cellValue);
        } else {
          if (row.sourceType == 0) {
            //工单
            return this.osg.codelabel("partnersOrgId", cellValue);
          } else {
            return this.osg.codelabel("partners", cellValue);
          }
        }
      } else if (row.type == 1) {
        // 平台对工队结算
        if (this.tenantId == "5103793983082511283") {
          return this.osg.codelabel("serviceResources", cellValue);
        } else {
          if (row.sourceType == 0) {
            //工单
            return this.osg.codelabel("partnersOrgId", cellValue);
          } else {
            return this.osg.codelabel("partners", cellValue);
          }
        }
      }
    },
    formatType(row, column, cellValue) {
      return this.osg.codelabel("type", cellValue);
    },
    formatSourceType(row, column, cellValue) {
      return this.osg.codelabel("sourceType", cellValue);
    },
    formatSourceTypeType(row, column, cellValue) {
      if (row.sourceType == 2) {
        // 合同
        return this.osg.codelabelForArray("contractType", cellValue);
        // return this.osg.formatCascade('contractType', cellValue);
      }
    },
    formatContractSubject(row, column, cellValue) {
      return this.osg.codelabel("contractSubject", cellValue);
    },
    formatSettleState(val) {
      return this.osg.codelabel("settleState", val);
    },
    formatRepairParts(row, column, cellValue) {
      if (cellValue) {
        return this.osg.formatCascade("repairParts", cellValue);
      }
    },
    formatContractStatus(row, column, cellValue) {
      if (!cellValue) {
        return "待签约";
      } else {
        return this.osg.codelabel("contractStatus", cellValue);
      }
    },
    formatPayState(row, column, cellValue) {
      return this.osg.codelabel("payState", cellValue);
    },
    formatUnlockPay(row, column, cellValue) {
      if (Array.isArray(cellValue)) {
        return cellValue.indexOf(Number(this.formData.type)) != -1
          ? "已解付"
          : "未解付";
      } else {
        return this.osg.codelabel("unlockPay", cellValue);
      }
    },
    formatUserId(row, column, cellValue) {
      return this.osg.codelabel("serviceResources", cellValue);
    },
    formatTargetType(row, column, cellValue) {
      return cellValue == 1 ? "工单" : cellValue == 2 ? "合同" : cellValue;
    },
    formatSignDate(row, column, cellValue) {
      return cellValue ? this.$util.readableTime(cellValue, "date") : "";
    },
    formatEndDate(row, column, cellValue) {
      return cellValue ? this.$util.readableTime(cellValue) : "";
    },
    pageSizeChange(pageSize) {
      this.fpi.rows = pageSize;
      this.getData();
    },
    pageChange(currentPage) {
      this.fpi.page = currentPage;
      this.getData();
    },
    doInit() {
      this.openDetail = false;
      this.formData = {
        toId: "",
        sourceTypeType: [],
        contractCompleteTime: [],
        exts: {
          ledgerJD_is: "",
          project_is: "",
        },
      };
      this.contracts = {
        fpi: {
          data: [],
        },
        selectedRows: [],
        loading: false,
      };
      this.$util.renderExtField(this.extFields, this.formData);
    },
    getData() {
      let params = {
        page: this.fpi.page,
        rows: this.fpi.rows,
        "regex:title|string#or": this.searchValue,
        "regex:num|string#or": this.searchValue,
        "in:state|array-integer#and": "0,1",
        sortField: "createTime",
        sortOrder: "desc",
      };
      //添加过滤器参数
      $that.getParams(params);
      this.osg.setFpi(params);
      this.osg.ajax("biz/settle/query.do", params, (res) => {
        // 解析json字符串的字段
        this.$util.renderExtFields(this.extFields, res.data);
        this.fpi = res;
        // 兼容safari浏览器表格
        this.$nextTick(() => {
          this.$refs.table.doLayout();
          this.$forceUpdate();
        });
      });
    },
    doNew(unlockPayState) {
      this.doInit();
      this.contracts.unlockPayState = unlockPayState;
      this.openDetail = true;
    },
    doEdit(row) {
      row = this.$util.deepCopy(row); //避免编辑内容后取消导致显示异常
      row.exts = row.exts || {};
      this.$util.renderExtField(this.extFields, row);
      // 组装datetimerange
      if (row.startTime && row.endTime) {
        row.datetimerange = [
          row.startTime && row.startTime.split(" ")[0],
          row.endTime && row.endTime.split(" ")[0],
        ];
      } else {
        row.datetimerange = [];
      }

      // 组装contractCompleteEndTime
      if (
        row.exts.contractCompleteStartTime &&
        row.exts.contractCompleteEndTime
      ) {
        row.contractCompleteTime = [
          row.exts.contractCompleteStartTime,
          row.exts.contractCompleteEndTime,
        ];
      } else {
        row.contractCompleteTime = [];
      }

      this.$forceUpdate();

      row.sourceTypeType = row.sourceTypeType || [];
      row.toId = row.toId || ""; // 避免必填校验提前出现
      if (this.tenantId == "1340835581184723420") {
        row.exts.ledgerJD_is = row.exts.ledgerJD_is || ""; //是否京东分账
        row.exts.project_is = row.exts.project_is || ""; //是否工程类项目
      }
      this.formData = row;
      this.contracts.unlockPayState = this.formData.unlockPayState;
      this.getContracts(true);
      this.openDetail = true;
    },
    doSave() {
      this.$util.saveExtField(this.extFields, this.formData);
      let params = this.$util.deepCopy(this.formData);
      params.settleState = params.settleState || 0;
      if (params.settleState != 0) {
        this.osg.alert("当前结算单状态不允许修改", () => {
          this.getData();
        });
        return;
      }
      if (this.osg.validate()) {
        params.startTime = params.startTime && params.startTime + " 00:00:00";
        params.endTime = params.endTime && params.endTime + " 23:59:59";
        // 结算来源id，targetType=0时为工单id，1时为订单id，2时为合同id
        let sourceTypeIdList = [];
        for (var item of this.contracts.selectedRows) {
          if (sourceTypeIdList.indexOf(item._id) == -1)
            sourceTypeIdList.push(item._id);
        }
        if (sourceTypeIdList.length == 0) {
          this.osg.alert("请至少勾选一条数据!", "warning");
          return;
        }
        params.sourceTypeIdList = sourceTypeIdList;

        // 付款方id（由结算对象来确定）
        switch (params.type) {
          case 0:
            params.fromId = this.tenantId;
            break;
          default:
            params.fromId = "";
        }
        // 解付状态
        params.unlockPayState = this.contracts.unlockPayState;

        // 保存完工日期筛选条件
        if (
          params.contractCompleteTime &&
          params.contractCompleteTime.length > 0
        ) {
          params.exts.contractCompleteStartTime =
            params.contractCompleteTime[0];
          params.exts.contractCompleteEndTime = params.contractCompleteTime[1];
        }
        delete params.contractCompleteTime;

        // 是否京东分账 是否工程类项目
        if (this.tenantId != "1340835581184723420") {
          delete params.exts.ledgerJD_is;
          delete params.exts.project_is;
        }

        this.osg.ajax("biz/settle/upsert.do", params, () => {
          this.doInit();
          this.getData();
          this.osg.toast("保存成功！");
        });
      }
    },
    doRemove(id) {
      this.osg.confirm("是否确认删除？", () => {
        this.osg.ajax(`biz/settle/remove/${id}.do`, null, () => {
          this.osg.toast("删除成功");
          this.getData();
        });
      });
    },
    getOrgs() {
      var params = {
        _all: "1",
        "is:state|integer#and": 1,
        sortField: "createTime",
        sortOrder: "desc",
      };
      this.osg.ajax(
        "org/query.do",
        params,
        (res) => {
          res.data.orgList.map((item) => {
            item.label = item.orgName;
            item.value = item._id;
          });
          this.options.orgs = res.data.orgList;
          this.$forceUpdate();
        },
        {
          noload: true,
        }
      );
    },
    getPartners() {
      var params = {
        _all: "1",
        "in:state|array-integer#and": "0,1",
        sortField: "createTime",
        sortOrder: "desc",
      };
      this.osg.ajax(
        "basic/partner/query.do",
        params,
        (res) => {
          res.data.map((item) => {
            item.label = item.name;
            item.value = item._id;
          });
          this.options.partners = res.data;
          // 工单
          this.options.partnersOrgId = this.$util.deepCopy(
            this.options.partners
          );
          this.options.partnersOrgId.map((item) => {
            item.value = item.orgId;
          });
          this.$forceUpdate();
        },
        {
          noload: true,
        }
      );
    },
    // 获取服务资源-对工队结算
    getServiceResources() {
      this.osg.ajax(
        "biz/serviceResource/query.do",
        {
          _all: "1",
          "is:state|integer#and": "1",
          resourceType: "technician",
        },
        (res) => {
          res.data.map((item) => {
            item.label = item.name;
            item.value = item.relatedRecordId;
          });
          this.options.serviceResources = res.data;
        }
      );
    },
    getContracts(edit, field) {
      if (!this.formData.sourceType && this.formData.sourceType != 0) {
        return;
      }
      //TODO:特殊的防水需求(1)根据选择运营商复制到结算单标题(2)添加运营中心字段
      if (this.tenantId == "1340835581184723420") {
        if (field == "toId") {
          let partnersFilterLIst = this.options.partners.filter(
            (item) => item.value == this.formData.toId
          );
          if (partnersFilterLIst.length) {
            this.$set(this.formData, "title", partnersFilterLIst[0].name); //根据选择运营商复制到结算单标题
            this.$set(
              this.formData.exts,
              "sTerritory",
              partnersFilterLIst[0].exts.sTerritory
            ); //添加运营中心字段
          }
        }
      }
      // 结算来源:工单
      if (this.formData.sourceType == 0) {
        this.getServiceAppointments(edit);
        return;
      }
      // 结算来源:考勤
      if (this.formData.sourceType == 3) {
        this.getSign(edit);
        return;
      }
      // 结算来源:合同
      if (!this.formData.toId) {
        return;
      }
      if (this.formData.datetimerange) {
        this.formData.startTime = this.formData.datetimerange[0];
        this.formData.endTime = this.formData.datetimerange[1];
      } else {
        this.formData.startTime = null;
        this.formData.endTime = null;
      }
      // 赋值contractCompleteTime
      this.formData.contractCompleteTime =
        this.formData.contractCompleteTime || [];

      this.contracts.loading = true;
      var params = {
        _all: "1",
        "gte:signedDate|datetime#and":
          this.formData.startTime && this.formData.startTime + " 00:00:00",
        "lte:signedDate|datetime#and":
          this.formData.endTime && this.formData.endTime + " 23:59:59",
        "gte:exts.realCompleteDateTime|datetime#and": this.formData
          .contractCompleteTime[0]
          ? this.formData.contractCompleteTime[0] + " 00:00:00"
          : null,
        "lte:exts.realCompleteDateTime|datetime#and": this.formData
          .contractCompleteTime[1]
          ? this.formData.contractCompleteTime[1] + " 23:59:59"
          : null,
        "nin:settlePayState|array-integer#or": this.formData.type,
        // 'in:_id|array#or': edit ? this.formData.sourceTypeIdList.join() : null,
        "in:_id|array#or": this.formData.sourceTypeIdList
          ? this.formData.sourceTypeIdList.join()
          : null,
        "in:exts.sourceType|string#and": this.formData.exts.contractSourceType, //用于过滤合同的信息来源
        "exists:exts.settleMark|boolean#and": false,
        "is:partnerId|string#and": this.formData.toId,
        "in:state|array-integer#and": "1,0",
        // 加条件 settledCandidate 不等于0
        "exists:settledCandidate|boolean#and": true,
        "ne:settledCandidate|integer#and": 0,
        
        sortField: "createTime",
        sortOrder: "desc"
      };
       // 筛选合同的支付状态
      if(!this.formData.payState){
        params['in:payState|array-integer#and'] = '1,2'
      }else{
        params['is:payState|integer#and']=this.formData.payState
      }

      // 过滤签约状态为已签约的合同
      if (this.tenantId == "1340835581184723420") {
        // params["is:exts.contractStatus|string#and"] = "10";
      }

      // dzm 解付状态非数组
      // if (this.tenantId == '1340835581184723420') {
      //     params['is:unlockPayState|integer#and'] = this.contracts.unlockPayState;
      // } else {
      // 修改
      // if (this.contracts.unlockPayState) {
      //   params["in:unlockPayState|array-integer#and"] = this.formData.type;
      // } else {
      //   params["nin:unlockPayState|array-integer#and"] = this.formData.type;
      // }
      // }

      // dzm 是否京东分账 是否工程类项目
      if (this.tenantId == "1340835581184723420") {
        if (this.formData.exts.ledgerJD_is == "0") {
          params["ne:exts.ledgerJD_is|string#and"] = "1";
        } else if (this.formData.exts.ledgerJD_is == "1") {
          params["is:exts.ledgerJD_is|string#and"] = "1";
        }
        if (this.formData.exts.project_is == "0") {
          params["ne:exts.project_is|string#and"] = "1";
        } else if (this.formData.exts.project_is == "1") {
          params["is:exts.project_is|string#and"] = "1";
        }
      }

      // 新增未解付结算单页面，只展示支付了金额的合同
      // if (!this.contracts.unlockPayState) {
      //   params["in:payState|array-integer#and"] = "1,2";
      // }
      // 合同类型
      if (this.formData.sourceType == 2) {
        // exts中数组不能传
        this.formData.sourceTypeType = this.formData.sourceTypeType || [];
        params["in:contractType|array#and"] =
          this.formData.sourceTypeType.toString();
      }
      this.osg.ajax(
        "basic/contract/query.do",
        params,
        (res) => {
          this.contracts.fpi = res;
          this.contracts.loading = false;
          this.$nextTick(() => {
            this.$refs.table2.doLayout();

            if (edit) {
              // 编辑结算单时 默认只勾选已选中的
              let rows = [];
              res.data.map((item) => {
                if (this.formData.sourceTypeIdList.indexOf(item._id) != -1)
                  rows.push(item);
              });
              this.toggleSelection(rows);
            } else {
              // 默认选中全部
              this.toggleSelection(res.data);
            }
            this.$forceUpdate();
          });
        },
        {
          noload: true,
        }
      );
    },
    // 查询工单
    getServiceAppointments(edit) {
      // if (!this.formData.toId) {
      //   return;
      // }
      if (this.formData.datetimerange) {
        this.formData.startTime = this.formData.datetimerange[0];
        this.formData.endTime = this.formData.datetimerange[1];
      } else {
        this.formData.startTime = null;
        this.formData.endTime = null;
      }
      // 赋值contractCompleteTime
      this.formData.contractCompleteTime =
        this.formData.contractCompleteTime || [];

      this.contracts.loading = true;
      var params = {
        _all: "1",
        "gte:createTime|datetime#and":
          this.formData.startTime && this.formData.startTime + " 00:00:00",
        "lte:createTime|datetime#and":
          this.formData.endTime && this.formData.endTime + " 23:59:59",
        // 'gte:exts.realCompleteDateTime|date#and': this.formData.contractCompleteTime[0]
        //   ? this.formData.contractCompleteTime[0] + ' 00:00:00'
        //   : null,
        // 'lte:exts.realCompleteDateTime|date#and': this.formData.contractCompleteTime[1]
        //   ? this.formData.contractCompleteTime[1] + ' 23:59:59'
        //   : null,
        "nin:settlePayState|array-integer#or": this.formData.type,
        // 'in:_id|array#or': edit ? this.formData.sourceTypeIdList.join() : null,
        "in:_id|array#or": this.formData.sourceTypeIdList
          ? this.formData.sourceTypeIdList.join()
          : null,
        sortField: "createTime",
        sortOrder: "desc",
      };
      // TODO:耐力股份不过滤结算条件，让他先过
      if (this.tenantId != "4746076824608392075") {
        if (this.contracts.unlockPayState) {
          params["in:unlockPayState|array-integer#and"] = this.formData.type;
        } else {
          params["nin:unlockPayState|array-integer#and"] = this.formData.type;
        }
      }

      if (this.formData.type == 1) {
        // 平台对工人结算
        params["is:exts.headManId|string#and"] = this.formData.toId;
      } else {
        // 平台对门店结算
        params["is:orgId|string#and"] = this.formData.toId;
      }

      // 新增未解付结算单页面，只展示支付了金额的合同
      // if (!this.contracts.unlockPayState) {
      //   params['in:payState|array-integer#and'] = '1,2';
      // }
      // 合同类型
      if (this.formData.sourceType == 2) {
        // exts中数组不能传
        this.formData.sourceTypeType = this.formData.sourceTypeType || [];
        // params['in:contractType|array#and'] = this.formData.sourceTypeType.toString();
        params["in:contractType|array#and"] =
          this.formData.sourceTypeType.toString();
      }
      this.osg.ajax(
        "basic/serviceAppointment/query.do",
        params,
        (res) => {
          this.contracts.fpi = res;
          this.contracts.loading = false;
          this.$nextTick(() => {
            this.$refs.table2.doLayout();

            if (edit) {
              // 编辑结算单时 默认只勾选已选中的
              let rows = [];
              res.data.map((item) => {
                if (this.formData.sourceTypeIdList.indexOf(item._id) != -1)
                  rows.push(item);
              });
              this.toggleSelection(rows);
            } else {
              // 默认选中全部
              this.toggleSelection(res.data);
            }
            this.$forceUpdate();
          });
        },
        {
          noload: true,
        }
      );
    },
    // 查询考勤表
    getSign(edit) {
      // if (!this.formData.toId) {
      //   return;
      // }
      if (this.formData.datetimerange) {
        this.formData.startTime = this.formData.datetimerange[0];
        this.formData.endTime = this.formData.datetimerange[1];
      } else {
        this.formData.startTime = null;
        this.formData.endTime = null;
      }

      this.contracts.loading = true;
      var params = {
        _all: "1",
        "gte:createTime|datetime#and":
          this.formData.startTime && this.formData.startTime + " 00:00:00",
        "lte:createTime|datetime#and":
          this.formData.endTime && this.formData.endTime + " 23:59:59",
        "nin:settlePayState|array-integer#or": this.formData.type,
        "in:_id|array#or": this.formData.sourceTypeIdList
          ? this.formData.sourceTypeIdList.join()
          : null,
        "is:userId|string#and": this.formData.toId,
        sortField: "createTime",
        sortOrder: "desc",
      };

      if (this.contracts.unlockPayState) {
        params["in:unlockPayState|array-integer#and"] = this.formData.type;
      } else {
        params["nin:unlockPayState|array-integer#and"] = this.formData.type;
      }

      this.osg.ajax(
        "/biz/sign/sign/query.do",
        params,
        (res) => {
          this.contracts.fpi = res;
          this.contracts.loading = false;
          this.$nextTick(() => {
            this.$refs.table2.doLayout();

            if (edit) {
              // 编辑结算单时 默认只勾选已选中的
              let rows = [];
              res.data.map((item) => {
                if (this.formData.sourceTypeIdList.indexOf(item._id) != -1)
                  rows.push(item);
              });
              this.toggleSelection(rows);
            } else {
              // 默认选中全部
              this.toggleSelection(res.data);
            }
            this.$forceUpdate();
          });
        },
        {
          noload: true,
        }
      );
    },
    // 指定选中合同
    toggleSelection(rows) {
      if (rows) {
        rows.forEach((row) => {
          this.$refs.table2.toggleRowSelection(row);
        });
        this.$forceUpdate();
      } else {
        this.$refs.table2.clearSelection();
      }
    },
    // 选中合同行变化时触发
    selectChange(rows) {
      this.contracts.selectedRows = rows;
    },
    // 列表多选
    selectSettles(rows) {
      this.selectedRows = rows;
    },
    // 审核
    audit(settleState) {
      /**
       * settleState
       * 0:待提交（服务商新建后是自由态-->状态设为0:待提交）
       * 1:待审核（服务商点提交审核-->状态改为1:待审核）
       * 2:撤回-动作（结算单状态为1未审核或4审核未通过时 服务商可以点撤回-->状态改为0:待提交）
       * 3:审核通过（平台点审核通过-->结算单状态改为2:审核通过）
       * 4:审核不通过（平台点审核通过-->结算单状态改为4:审核不通过）
       * 5:反审-动作（结算单状态为2或4已审核时 平台可以点反审-->结算单状态改为1:待审核）
       */
      // 至少选择一个结算单
      if (this.selectedRows.length == 0) {
        this.osg.toast("请至少选择一个结算单", "warning");
        return;
      }
      // 判断选择的结算单状态是否符合审核条件
      let msg = "";
      let confirmMsg = "";
      switch (settleState) {
        case "1":
          for (let settle of this.selectedRows) {
            if (settle.settleState != "0") {
              this.osg.alert(
                `您选择的结算单"${settle.title}"状态 不符合"提交审核"条件`,
                "warning"
              );
              return;
            }
          }
          confirmMsg = "提交审核";
          msg = "提交成功，待审核。";
          break;
        case "2":
          for (let settle of this.selectedRows) {
            if (settle.settleState != "1" && settle.settleState != "4") {
              this.osg.alert(
                `您选择的结算单"${settle.title}"状态 不符合"撤回修改"条件`
              );
              return;
            }
          }
          confirmMsg = "撤回修改";
          msg = "撤回成功，可修改后重新提交。";
          break;
        case "3":
          for (let settle of this.selectedRows) {
            if (settle.settleState != "1") {
              this.osg.alert(
                `您选择的结算单"${settle.title}"状态 不符合"审核"条件`
              );
              return;
            }
          }
          confirmMsg = "审核通过";
          msg = "审核通过，处理完成。";
          break;
        case "4":
          for (let settle of this.selectedRows) {
            if (settle.settleState != "1") {
              this.osg.alert(
                `您选择的结算单"${settle.title}"状态 不符合"审核"条件`
              );
              return;
            }
          }
          confirmMsg = "审核不通过";
          msg = "审核不通过，处理完成。";
          break;
        case "5":
          for (let settle of this.selectedRows) {
            if (settle.settleState != "2" && settle.settleState != "4") {
              this.osg.alert(
                `您选择的结算单"${settle.title}"还未审核 不符合"反审"条件`
              );
              return;
            }
          }
          confirmMsg = "反审";
          msg = "反审处理完成，结算单状态改为待审核。";
          break;
        default:
      }
      // 确认框
      if (settleState != "4") {
        this.osg.confirm(`是否确认${confirmMsg}`, () => {
          this.auditConfirm(settleState, msg);
        });
      } else {
        this.auditObj.show = true;
      }
    },
    auditConfirm(settleState, msg) {
      if (settleState == "4") {
        if (!this.osg.validate("audit")) return;
      }
      let settleIds = [];
      this.selectedRows.map((item) => {
        settleIds.push(item._id);
      });
      this.osg.ajax(
        `/biz/settle/repapprove/${settleState}.do`,
        {
          settleIds: settleIds.join(),
          remark: this.auditObj.remark || null,
        },
        () => {
          this.osg.toast(msg);
          this.auditObj.remark = "";
          this.auditObj.show = false;
          this.getData();
        }
      );
    },
  },
};
</script>
<style lang="scss">
.settles .c-dialog.el-dialog {
  width: 90% !important;
  height: 90% !important;
  .el-dialog__body {
    padding: 20px !important;
  }
}
#app .settles .c-dialog.el-dialog {
  max-height: 90vh !important;
  margin: 5vh auto 5vh !important;
  margin-top: 5vh !important;
}
// .c-form-item > div:not(:last-child) {
//   width: 45%;
//   float: left;
// }
// .c-form-item > div:nth-child(even):not(:last-child) {
//   margin-left: 10%;
// }
.c-form-item > div {
  width: 45%;
  float: left;
}
.c-form-item > div:nth-child(even) {
  margin-left: 10%;
}
.c-date-picker {
  height: 33px !important;
}
</style>
